import React from "react";
import { SelectionContext } from "./SelectAssets";

export default function SelectAllCell(/* { onChange } */){
	return (
		<label className="select-cell select-all-cell checkbox-select-container">
			<SelectionContext.Consumer>
				{({ isAllSelected, selectAll }) => {
					return (
						<React.Fragment>
							<input
								type="checkbox"
								checked = {isAllSelected}
								className="custom-checkbox"
								onChange = {(e) => {
									let { currentTarget: { checked } } = e;
									// onChange(checked);
									selectAll(checked);
								}}
							/>
							<span className="pretty-checkbox" />
						</React.Fragment>
					);
				}}
			</SelectionContext.Consumer>
		</label>
	);
}

SelectAllCell.displayName = "SelectAllCell";
